import axios from 'axios'
import { useContext, useState } from 'react'
import { UserContext } from '../../context api/UserContext'
import { formTokenHeader } from '../../lib/HeaderHelper'
import { useRestApi } from '../../lib/RestApi/useRestApi'
import { bulkUploadPopup, toastMessage } from '../../shared/AlertPopup'
import { API } from '../../shared/API'
import { error, success } from '../../shared/constants'

export const useBulkUpload = (redirect, addNewData) => {
  console.log('HERE')
  const [loading, setLoading] = useState(false)
  const user = useContext(UserContext)
  const token = user && user.token
  const header = formTokenHeader(token)

  const BulkUpload = async (dto) => {
    setLoading(true)
    axios
      .post(API.BULK_UPLOAD, dto, header)
      .then(({ status, data }) => {
        //console.log('DATA : ', data)
        setLoading(false)
        if (status !== 201) {
          return toastMessage('Something Went Wrong !', error)
        }
        toastMessage(data.message, success)
        bulkUploadPopup(data, addNewData)
        // window.location.reload()

        // setInterval(() => {
        //   window.location.reload()
        // }, 1000)

        // redirect()
      })
      .catch((err) => {
        //console.log(err)
        setLoading(false)
        if (err.response) {
          //console.log(err.response)
          return toastMessage(err.response.data.error, error)
        }
      })
  }
  return {
    BulkUpload,
    loading,
  }
}
